import { AUTH_REFRESH_TOKEN, AUTH_TOKEN, AUTH_CONFIRM_EMAIL_TOKEN } from 'constants/AuthConstant';
import { jwtDecode } from 'jwt-decode';


const userService = {}

userService.getCurrentUser = function () {
  const token = localStorage.getItem(AUTH_TOKEN)

  if (token) {
    try {
      const user = jwtDecode(token);
      return user;
    } catch (error) {
      console.error('UserService.getCurrentUser - Invalid JWT token', error);
      localStorage.removeItem(AUTH_TOKEN);
    }
  } else {
    console.warn('UserService.getCurrentUser - No JWT token found in localStorage');
  }
}

userService.getCurrentApelidoEvento = function () {
  const token = localStorage.getItem(AUTH_TOKEN)

  if (token) {
    try {
      return jwtDecode(token).apelidoEvento;
    } catch (error) {
      console.error('Invalid JWT token', error);
      localStorage.removeItem(AUTH_TOKEN);
    }
  } else {
    console.warn('No JWT token found in localStorage');
  }
}


userService.getCurrentUserToConfirmEmail = function () {
  const token = localStorage.getItem(AUTH_CONFIRM_EMAIL_TOKEN)

  if (token) {
    try {
      return jwtDecode(token);
    } catch (error) {
      console.error('Invalid JWT token', error);
    }
  } else {
    console.warn('No JWT token found in localStorage');
  }
}

userService.getToken = function () {
  return localStorage.getItem(AUTH_TOKEN)
}

userService.getRefreshToken = function () {
  return localStorage.getItem(AUTH_REFRESH_TOKEN)
}

userService.getCurrentUserRoles = function () {
  const token = localStorage.getItem(AUTH_TOKEN)

  if (token) {
    try {
      const user = jwtDecode(token);
      return user.roles || [];
    } catch (error) {
      console.error('Invalid JWT token', error);
      localStorage.removeItem(AUTH_TOKEN);
      return [];
    }
  } else {
    console.warn('No JWT token found in localStorage');
    return [];
  }
}


export default userService